<script>
export default {
    name: "SmallButtonSvg"
}
</script>
<template>
    <svg id="Group_914" data-name="Group 914" xmlns="http://www.w3.org/2000/svg" width="29.41" height="29.41" viewBox="0 0 29.41 29.41">
        <path class="stMobileBtnCareers1" id="Path_1070" data-name="Path 1070" d="M0,12.221,12.221,0,24.441,12.221" transform="translate(18.784 2.571) rotate(90)" fill="none"  stroke-width="1"/>
        <g class="stMobileBtnCareers1" id="Ellipse_48" data-name="Ellipse 48" fill="none" stroke-width="1">
            <ellipse cx="14.705" cy="14.705" rx="14.705" ry="14.705" stroke="none"/>
            <ellipse cx="14.705" cy="14.705" rx="14.205" ry="14.205" fill="none"/>
        </g>
    </svg>
</template>
<style lang="css" scoped>
    .stMobileBtnCareers0{fill:#FFFFFF;}
    .stMobileBtnCareers1{stroke:#FFFFFF;}
</style>
